import {
    ADD_LIST,
    ADD_MODAL_CREATE_LIST,
    ADD_ARTICLE_DETAIL,
    ADD_MODAL_RENAME_LIST,
    ADD_MODAL_DELETE_LIST,
} from '../../constants/ListConstants'


export default function ListReducer(state = {}, action) {
    switch (action.type) {
        case ADD_LIST:
            return {
                ...state,
                ...action.payload
            };
        case ADD_MODAL_CREATE_LIST:
            return {
                ...state,
                ...action.payload
            };
        case ADD_ARTICLE_DETAIL:
            return {
                ...state,
                ...action.payload
            };
        case ADD_MODAL_RENAME_LIST:
            return {
                ...state,
                ...action.payload
            };
        case ADD_MODAL_DELETE_LIST:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ListReducer.js